import React, { useEffect, useState } from "react";
import "./ourProjects.css";
import { useLocation } from "react-router-dom";

const OurProjects = ({ imageFiles, projectHeading }) => {
  const location = useLocation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Auto-slide carousel
  useEffect(() => {
    if (imageFiles.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % imageFiles.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [imageFiles.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + imageFiles.length) % imageFiles.length
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % imageFiles.length);
  };

  const openLightbox = (index) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  // Keyboard navigation for carousel and lightbox
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (selectedImage !== null) {
        if (e.key === "Escape") {
          setSelectedImage(null);
        } else if (e.key === "ArrowLeft") {
          setSelectedImage(
            (prev) => (prev - 1 + imageFiles.length) % imageFiles.length
          );
        } else if (e.key === "ArrowRight") {
          setSelectedImage((prev) => (prev + 1) % imageFiles.length);
        }
      } else {
        if (e.key === "ArrowLeft") {
          setCurrentIndex(
            (prev) => (prev - 1 + imageFiles.length) % imageFiles.length
          );
        } else if (e.key === "ArrowRight") {
          setCurrentIndex((prev) => (prev + 1) % imageFiles.length);
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [selectedImage, imageFiles.length]);

  return (
    <>
      <div className="our_project_body">
        <div className="our_project_headingnn">{projectHeading}</div>

        <div className="modern_carousel">
          <div className="carousel_container">
            {/* Main Slide */}
            <div
              className="carousel_slide"
              onClick={() => openLightbox(currentIndex)}
            >
              <img
                src={imageFiles[currentIndex]}
                alt={`${projectHeading} - Image ${currentIndex + 1}`}
                className="carousel_main_image"
                loading="lazy"
              />
              <div className="carousel_overlay">
                <span className="carousel_icon">🔍 Click to expand</span>
              </div>
            </div>

            {/* Navigation Arrows */}
            {imageFiles.length > 1 && (
              <>
                <button
                  className="carousel_arrow carousel_arrow_left"
                  onClick={goToPrevious}
                  aria-label="Previous image"
                >
                  ‹
                </button>
                <button
                  className="carousel_arrow carousel_arrow_right"
                  onClick={goToNext}
                  aria-label="Next image"
                >
                  ›
                </button>
              </>
            )}

            {/* Image Counter */}
            {imageFiles.length > 1 && (
              <div className="carousel_counter">
                {currentIndex + 1} / {imageFiles.length}
              </div>
            )}
          </div>

          {/* Thumbnail Navigation */}
          {imageFiles.length > 1 && (
            <div className="carousel_thumbnails">
              {imageFiles.map((image, index) => (
                <button
                  key={index}
                  className={`carousel_thumbnail ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to image ${index + 1}`}
                >
                  <img
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    className="thumbnail_image"
                  />
                </button>
              ))}
            </div>
          )}

          {/* Dots Navigation (for mobile) */}
          {imageFiles.length > 1 && (
            <div className="carousel_dots">
              {imageFiles.map((_, index) => (
                <button
                  key={index}
                  className={`carousel_dot ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox_close" onClick={closeLightbox}>
            ✕
          </button>
          <button
            className="lightbox_nav lightbox_prev"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(
                (prev) => (prev - 1 + imageFiles.length) % imageFiles.length
              );
            }}
          >
            ‹
          </button>
          <button
            className="lightbox_nav lightbox_next"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage((prev) => (prev + 1) % imageFiles.length);
            }}
          >
            ›
          </button>
          <div
            className="lightbox_content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={imageFiles[selectedImage]}
              alt={`${projectHeading} - Image ${selectedImage + 1}`}
              className="lightbox_image"
            />
            <div className="lightbox_counter">
              {selectedImage + 1} / {imageFiles.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OurProjects;
